var map = {
	"./apple.svg": 4941,
	"./appstore.svg": 7892,
	"./back-to-top-button.svg": 107,
	"./bdnews24-logo.svg": 5394,
	"./black-fb.svg": 8091,
	"./black-home-icon.svg": 8363,
	"./black-print.svg": 1475,
	"./black-share.svg": 3556,
	"./black-twitter.svg": 3534,
	"./black-whatsapp.svg": 6223,
	"./black-zoom-in.svg": 6110,
	"./black-zoom-out.svg": 9736,
	"./clock.svg": 7062,
	"./close.svg": 9525,
	"./copy.svg": 1063,
	"./down-chevron.svg": 6366,
	"./downarrow.svg": 3300,
	"./facebook.svg": 7027,
	"./gears.svg": 1754,
	"./google.svg": 6874,
	"./googleplay.svg": 5956,
	"./home-icon.svg": 4412,
	"./instagram.svg": 7693,
	"./lang.svg": 3167,
	"./linkedin.svg": 9097,
	"./live-icon.svg": 5720,
	"./loading.svg": 2178,
	"./mail.svg": 4617,
	"./photo.svg": 1496,
	"./rightarrow.svg": 4599,
	"./search.svg": 6759,
	"./twitter.svg": 8502,
	"./twitter_x2.svg": 3885,
	"./user-icon.svg": 4382,
	"./user.svg": 6781,
	"./video.svg": 1984,
	"./whatsapp.svg": 9665,
	"./white-close.svg": 183,
	"./white-fb.svg": 4865,
	"./youtube.svg": 2934
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1006;